import { createSelector } from 'reselect';

export const userDataSelector = state => state?.referral?.user || {};

export const referralEligibilityDataSelector = createSelector(
  userDataSelector,
  ({
    userID,
    referralCallbackStatus,
    couponPresent,
    inviteAndEarn,
    trialPeriod,
    phoneVerified,
    locale,
    isUgBannerActive,
    hasReferred,
  }) => ({
    userID,
    referralCallbackStatus,
    couponPresent,
    inviteAndEarn,
    trialPeriod,
    phoneVerified,
    locale,
    isUgBannerActive,
    hasReferred,
  }),
);
